// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Paper = require("@mui/material/Paper").default;
var Button = require("@mui/material/Button").default;

function MM_cmp_save_or_discard(Props) {
  var contOld = Props.contOld;
  var removeStmtOpt = Props.removeStmt;
  var contNew = Props.contNew;
  var onDiscard = Props.onDiscard;
  var onSave = Props.onSave;
  var onContinueEditing = Props.onContinueEditing;
  var removeStmt = removeStmtOpt !== undefined ? removeStmtOpt : false;
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: React.createElement(Expln_React_Column.make, {
                    spacing: 1,
                    children: null
                  }, React.createElement(Expln_React_Row.make, {
                        children: React.createElement("span", {
                              style: {
                                fontWeight: "bold"
                              }
                            }, "Discard changes or save?")
                      }), React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, React.createElement(Button, {
                                        onClick: (function (param) {
                                            Curry._1(onDiscard, undefined);
                                          }),
                                        children: removeStmt ? "Discard, remove statement" : "Discard, use this \u2192"
                                      })), React.createElement("td", undefined, removeStmt ? null : contOld)), React.createElement("tr", undefined, React.createElement("td", undefined, React.createElement(Button, {
                                        onClick: (function (param) {
                                            Curry._1(onSave, undefined);
                                          }),
                                        children: "Save, use this \u2192"
                                      })), React.createElement("td", undefined, contNew)))), React.createElement(Button, {
                        onClick: (function (param) {
                            Curry._1(onContinueEditing, undefined);
                          }),
                        children: "Continue Editing"
                      }))
            });
}

var make = MM_cmp_save_or_discard;

exports.make = make;
/* react Not a pure module */
